import { render, staticRenderFns } from "./LastLogs.vue?vue&type=template&id=492ae511&"
import script from "./LastLogs.vue?vue&type=script&lang=ts&"
export * from "./LastLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports